module.exports = __webpack_public_path__ + "img/icon_02.e297d99d.svg";